import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _Symbol$iterator;
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { ListNode } from './node';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
_Symbol$iterator = Symbol.iterator;
export var List = /*#__PURE__*/function () {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function List(value) {
    _classCallCheck(this, List);
    _defineProperty(this, "nodes", new Map());
    _defineProperty(this, "firstId", null);
    _defineProperty(this, "lastId", null);
    _defineProperty(this, "uniqueIdGenerator", 0);
    if (typeof value !== 'undefined') {
      this.addFirstNode(value);
    }
  }
  _createClass(List, [{
    key: "head",
    value: function head() {
      if (this.firstId === null) {
        return null;
      }

      // Это fallback, такого не может произойти, только если руками будет удален первый элемент
      /* istanbul ignore next */
      return this.nodes.get(this.firstId) || null;
    }
  }, {
    key: "tail",
    value: function tail() {
      if (this.lastId === null) {
        return null;
      }

      // Это fallback, такого не может произойти, только если руками будет удален последний элемент
      /* istanbul ignore next */
      return this.nodes.get(this.lastId) || null;
    }
  }, {
    key: "size",
    get: function get() {
      return this.nodes.size;
    }
  }, {
    key: "getNode",
    value: function getNode(id) {
      return this.nodes.get(id) || null;
    }
  }, {
    key: "add",
    value: function add(value) {
      var prevTail = this.tail();
      if (!prevTail) {
        return this.addFirstNode(value);
      }
      var uniqueId = this.generateNodeId();
      var tail = new ListNode(uniqueId, value, prevTail, null);
      prevTail.setNext(tail);
      this.lastId = uniqueId;
      this.nodes.set(uniqueId, tail);
      return tail;
    }
  }, {
    key: "remove",
    value: function remove(id) {
      var currentNode = this.nodes.get(id);
      if (!currentNode) {
        return;
      }
      var prevNode = currentNode.prev();
      var nextNode = currentNode.next();
      this.nodes.delete(id);
      if (prevNode && nextNode) {
        prevNode.setNext(nextNode);
        nextNode.setPrev(prevNode);
        return;
      }
      if (!prevNode && nextNode) {
        this.firstId = nextNode.id;
        nextNode.setPrev(null);
        return;
      }
      if (prevNode && !nextNode) {
        this.lastId = prevNode.id;
        prevNode.setNext(null);
        return;
      }
      this.lastId = null;
      this.firstId = null;
    }
  }, {
    key: "isTail",
    value: function isTail(node) {
      var id = typeof node === 'number' ? node : node.id;
      return id === this.lastId;
    }
  }, {
    key: "find",
    value: function find(predicate) {
      var _iterator = _createForOfIteratorHelper(this),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _node = _step.value;
          if (predicate(_node)) {
            return _node;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return null;
    }
  }, {
    key: "findLast",
    value: function findLast(predicate) {
      var node = this.tail();
      if (!node) {
        return null;
      }
      if (predicate(node)) {
        return node;
      }
      while (node = node.prev()) {
        if (predicate(node)) {
          return node;
        }
      }
      return null;
    }
  }, {
    key: _Symbol$iterator,
    value: function value() {
      var node = this.head();
      return {
        next: function next() {
          if (!node) {
            return {
              done: true,
              value: node
            };
          }
          var currentNode = node;
          node = node.next();
          return {
            done: false,
            value: currentNode
          };
        }
      };
    }
  }, {
    key: "addFirstNode",
    value: function addFirstNode(value) {
      var uniqueId = this.generateNodeId();
      this.firstId = uniqueId;
      this.lastId = uniqueId;
      var head = new ListNode(uniqueId, value, null, null);
      this.nodes.set(uniqueId, head);
      return head;
    }
  }, {
    key: "generateNodeId",
    value: function generateNodeId() {
      return ++this.uniqueIdGenerator;
    }
  }]);
  return List;
}();